var _defs, _text, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 181.421,
    height: 36,
    viewBox: "0 0 181.421 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#593a7c;}.a{font-size:29px;font-family:Montserrat-SemiBold, Montserrat;font-weight:600;}"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "a",
    transform: "translate(118.421 28)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -62.509,
    y: 0
  }, "FUTURU"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1981.876,3774.368a38.944,38.944,0,0,1,6.637-.668,37.073,37.073,0,0,1,6.538.668,26.163,26.163,0,0,1,5.609-5.711c2.8-1.79,5.068-1.647,5.935-1.168s1.538,1.414,1.753,5.412a54.7,54.7,0,0,1-.461,8.832s2.567,4.8,1.891,9.161c-.29,2.706-1.589,4.627-6.808,7.691s-10.584,4.563-14.068,4.563-8.591-1.448-14.671-4.563c-4.349-2.228-6.589-5.95-6.964-7.691-.884-4.1,1.975-9.7,1.975-9.7a41.875,41.875,0,0,1-.416-8.291c.321-3.5.489-4.872,1.455-5.412s3.295-.622,6.132,1.168S1981.876,3774.368,1981.876,3774.368Z",
    transform: "translate(-1967.098 -3767.148)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b65e6f27.svg";
export { ForwardRef as ReactComponent };